import { Menu, MenuHandler, MenuList } from "@material-tailwind/react";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as notifyApi from "../../../service/notifyApi";
import MenuInfoProvideradmin from "./MenuInfoProvideradmin";
import ToggleIcon from "../../admin/toggleCard/ToggleIcon";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { CurrentUserContext } from "../../../App";

function MenuProvideradmin({ menuActive, submenuActive }) {
  const { userRole, setUserRole, setIsMessage } =
    useContext(CurrentUserContext);

  const navigate = useNavigate();
  const [toggle, setToggle] = useState(false);
  const [toggleSubmenu, setToggleSubmenu] = useState(false);
  const [loading, setLoading] = useState(false);
  const [notifyList, setNotifyList] = useState([]);
  const [page, setPage] = useState(1);
  const [getNotificationTotal, setGetNotificationTotal] = useState(
    localStorage.getItem("Notification"),
  );
  const [openModalApprove, setOpenModalApprove] = useState(false);
  const [itemOnClickNotify, setItemOnClickNotify] = useState("");
  const [checkUserAfterLogin, setCheckUserAfterLogin] = useState(
    localStorage.getItem("user"),
  );

  const [open, setOpen] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    if (localStorage.getItem("Notification") === null) {
      setGetNotificationTotal(0);
    } else {
      // console.log(getNotificationTotal)
    }
    // getRequestPermission()
    setUserRole(user); //ใช้อัพเดท route path ทุกครั้งถ้ามีการ อัพเดท
  }, [checkUserAfterLogin]);

  const [widtht, setWidth] = useState(0);

  useEffect(() => {
    const updateWindowDimensions = () => {
      const newWidth = window.innerWidth;
      setWidth(newWidth);
      // console.log("updating Width");
    };

    window.addEventListener("resize", updateWindowDimensions);

    return () => window.removeEventListener("resize", updateWindowDimensions);
  }, []);

  useEffect(() => {
    if (widtht > 767) {
      setOpen(false);
    }
  }, [widtht]);

  const getRequestPermission = async () => {
    setLoading(true);
    let res = await notifyApi.getNotification(page, 10);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        // console.log(res['data'])
        setNotifyList(res["data"]["notification_list"]);
        localStorage.setItem(
          "Notification",
          res["data"]["notification_list"].length,
        );
      } else if (res["data"]["code"] === 401) {
        setIsMessage({ type: "error", data: "หมดเวลาใช้งาน" });
        localStorage.clear();
        navigate("/login");
        return;
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const setReadNotification = async () => {
    setLoading(true);
    let res = await notifyApi.setReadNotification(page, 10);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        // console.log(res['data'])
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  return (
    <nav className="bg-white z-10 fixed top-0 left-0 right-0 h-28 md:h-[70px] w-full shadow-xl rounded-b-3xl flex justify-between items-center">
      {/* logo&appname */}
      <div className="flex">
        <button onClick={() => navigate("/manager/aggregateResult")}>
          <img
            className="ml-[50px] lg:ml-[30px] md:ml-[20px] sm:ml-0xsm:ml-0 lg:h-[50px] md:h-[20px] sm:h-[10px]"
            src={require("../../../asset/image/logo.svg").default}
            alt=""
          ></img>
        </button>
      </div>

      {/* mobile */}
      <div className="flex justify-end items-center gap-10 invisible text-3xl absolute right-10 top-15 md:visible">
        <ul>
          <Menu open={open}>
            <MenuHandler>
              <div>
                {open ? (
                  <XMarkIcon
                    onClick={() => setOpen(!open)}
                    className="w-6 stroke-[#FF9768] stroke-[3px]"
                  />
                ) : (
                  <Bars3Icon
                    onClick={() => setOpen(!open)}
                    className="w-6 stroke-[#FF9768] stroke-[3px]"
                  />
                )}
              </div>
            </MenuHandler>
            <MenuList className="flex flex-col items-center md:gap-y-3 gap-y-5 h-[510px] md:h-auto rounded-3xl ">
              <Menu open={toggleSubmenu}>
                <MenuHandler
                  onClick={() => {
                    setToggleSubmenu(!toggleSubmenu);
                  }}
                >
                  <div className="flex items-center justify-center gap-2">
                    <p
                      className={`${menuActive === "ผลสรุป" ? "text-[#FF9768] font-bold" : "text-[#000000]"} text-md`}
                    >
                      ผลสรุป
                    </p>
                    <ToggleIcon
                      storkeNoneColor={
                        menuActive === "ผลสรุป" ? "showcolor" : "nonecolor"
                      }
                      toggleCards
                      onToggle={() => {
                        setToggleSubmenu(!toggleSubmenu);
                      }}
                      toggleStatus={toggleSubmenu}
                    />
                  </div>
                </MenuHandler>
                <MenuList className="flex flex-col items-start gap-y-2 rounded-3xl">
                  <div
                    onClick={() => navigate("/manager/aggregateResult")}
                    className="flex justify-center text-left"
                  >
                    <p
                      className={`${submenuActive === "resultcount" ? "text-[#FF9768] font-bold" : "text-[#000000]"} text-sm`}
                    >
                      สรุปจำนวนการเข้าใช้งาน
                    </p>
                  </div>
                  <div
                    onClick={() => navigate("/manager/geneResult")}
                    className="flex justify-center text-left"
                  >
                    <p
                      className={`${submenuActive === "resultall" ? "text-[#FF9768] font-bold" : "text-[#000000]"} text-sm`}
                    >
                      สรุปผลการตรวจทั้งหมด
                    </p>
                  </div>
                  <div
                    onClick={() => navigate("/manager/inspectionRateMap")}
                    className="flex justify-center text-left"
                  >
                    <p
                      className={`${submenuActive === "maplocation" ? "text-[#FF9768] font-bold" : "text-[#000000]"} text-sm`}
                    >
                      แผนที่แสดงตำแหน่งที่ตั้ง
                    </p>
                  </div>
                </MenuList>
              </Menu>
              <div
                onClick={() => navigate("/manager/guideline")}
                className={`text-md ${menuActive === "guideCheckInspec" ? "text-[#FF9768] font-bold" : "text-[#000000]"}`}
              >
                แนวทางการตรวจ
              </div>
              <div
                onClick={() => navigate("/manager/relatedinfo")}
                className={`text-md ${menuActive === "relatedinfo" ? "text-[#FF9768] font-bold" : "text-[#000000]"}`}
              >
                ข้อมูลที่เกี่ยวข้อง
              </div>
              <div
                onClick={() => navigate("/manager/contact")}
                className={`text-md ${menuActive === "contact" ? "text-[#FF9768] font-bold" : "text-[#000000]"} `}
              >
                ติดต่อเรา
              </div>
              <div className="border-[1px] border-solid border-[#FF9768] w-full bg-[#FF9768]"></div>
              <div className="flex flex-col gap-3 justify-center items-center">
                <img
                  className={
                    user?.profile_image
                      ? "w-[48px] h-[48px] lg:w-[30px] lg:h-[30px] rounded-full"
                      : "w-[48px] h-[48px] lg:w-[30px] lg:h-[30px]"
                  }
                  src={
                    user?.profile_image
                      ? user?.profile_image
                      : require("../../../asset/icon/iconuser.svg").default
                  }
                  alt="iconuser"
                />
                <p className="text-[#FF9768] text-lg font-medium px-3 lg:text-xs">
                  {user?.fname + " " + user?.lname}
                </p>
              </div>

              <div className="flex flex-col items-center gap-y-2 md:w-full">
                <div
                  onClick={() => {
                    navigate("/manager/manageinfo");
                  }}
                  className="md:w-full text-center button-theme-pg bg-[#FF9768] rounded-full text-white text-[10px]"
                >
                  จัดการข้อมูลส่วนตัว
                </div>
                <div
                  onClick={() => {
                    navigate("/manager/changepassword");
                  }}
                  className="md:w-full text-center button-theme-pg bg-[#FF9768] rounded-full text-white text-[10px]"
                >
                  เปลี่ยนรหัสผ่าน
                </div>
                <div
                  onClick={() => {
                    navigate("/manager/about");
                  }}
                  className="md:w-full text-center button-theme-pg bg-[#FF9768] rounded-full text-white text-[10px]"
                >
                  เกี่ยวกับเรา
                </div>
              </div>

              <div
                onClick={() => {
                  localStorage.clear();
                  navigate("/login");
                }}
                className="flex justify-center items-center bg-white rounded-full w-[120px] md:w-full h-[25px] ring-1 ring-[#FF9768]"
              >
                <img
                  src={require("../../../asset/icon/logout.svg").default}
                  alt=""
                  className="mr-2 w-[12px]"
                />
                <p className="text-[#FF9768] text-xs">ออกจากระบบ</p>
              </div>
            </MenuList>
          </Menu>
        </ul>
      </div>

      {/* web */}
      <ul className="h-12 flex items-center md:hidden">
        {/* ผบสรุป */}
        <li>
          <Menu open={toggle}>
            <MenuHandler
              onClick={() => {
                setToggle(!toggle);
              }}
            >
              <button className="flex h-full items-center mr-11 px-3 hover:drop-shadow-sm">
                <p
                  className={`${menuActive === "ผลสรุป" ? "text-[#FF9768] font-bold" : "text-[#000000]"} text-lg px-3`}
                >
                  ผลสรุป
                </p>
                <ToggleIcon
                  storkeNoneColor={
                    menuActive === "ผลสรุป" ? "showcolor" : "nonecolor"
                  }
                  toggleCards
                  onToggle={() => {
                    setToggle(!toggle);
                  }}
                  toggleStatus={toggle}
                />
              </button>
            </MenuHandler>
            <MenuList
              dismiss
              className="flex flex-col items-start mt-7 w-80 rounded-3xl"
            >
              <button
                onClick={() => navigate("/manager/aggregateResult")}
                className=" flex justify-center text-left mt-2 pl-4 py-2"
              >
                <p
                  className={`${submenuActive === "resultcount" ? "text-[#FF9768] font-bold" : "text-[#000000]"} hover:text-[#FF9768] hover:text-[18.5px] transition-all duration-500 ease-in-out text-lg`}
                >
                  สรุปจำนวนการเข้าใช้งาน
                </p>
              </button>
              <button
                onClick={() => navigate("/manager/geneResult")}
                className=" flex justify-center text-left mt-2 pl-4 py-2"
              >
                <p
                  className={`${submenuActive === "resultall" ? "text-[#FF9768] font-bold" : "text-[#000000]"} hover:text-[#FF9768] hover:text-[18.5px] transition-all duration-500 ease-in-out text-lg`}
                >
                  สรุปผลการตรวจทั้งหมด
                </p>
              </button>
              <button
                onClick={() => navigate("/manager/inspectionRateMap")}
                className=" flex justify-center text-left mt-2 pl-4 py-2"
              >
                <p
                  className={`${submenuActive === "maplocation" ? "text-[#FF9768] font-bold" : "text-[#000000]"} hover:text-[#FF9768] hover:text-[18.5px] transition-all duration-500 ease-in-out text-lg`}
                >
                  แผนที่แสดงตำแหน่งที่ตั้ง
                </p>
              </button>
            </MenuList>
          </Menu>
        </li>
        {/* จัดการข้อมูลเว็บไซต์ */}
        {/* <li>
                    <button
                        onClick={() => {
                            navigate('/manager/guideline')
                        }}
                        className={`mr-5 xl:mr-2 text-lg xl:text-md ${menuActive === 'guideCheckInspec' ? 'text-[#FF9768]' : 'text-[#000000]'} hover:text-[#FF9768]`}
                    >
                        แนวทางการตรวจ
                    </button>
                </li> */}
        <li>
          <button
            onClick={() => navigate("/manager/relatedinfo")}
            className={`mr-5 xl:mr-2 text-lg xl:text-md ${menuActive === "relatedinfo" ? "text-[#FF9768] font-bold" : "text-[#000000]"} hover:text-[#FF9768]`}
          >
            ข้อมูลที่เกี่ยวข้อง
          </button>
        </li>
        {/* คำถามที่พบบ่อย */}
        {/* <li>
                    <button
                        onClick={() => navigate('/manager/ans')}
                        className={`mr-5 xl:mr-2 text-lg xl:text-md  ${menuActive === 'ans' ? 'text-[#FF9768]' : 'text-[#000000]'} hover:text-[#FF9768]`}
                    >
                        คำถามที่พบบ่อย
                    </button>
                </li> */}
        {/* ติดต่อเรา */}
        <li>
          <button
            onClick={() => navigate("/manager/contact")}
            className={`mr-5 xl:mr-2 text-lg xl:text-md  ${menuActive === "contact" ? "text-[#FF9768] font-bold" : "text-[#000000]"} hover:text-[#FF9768]`}
          >
            ติดต่อเรา
          </button>
        </li>
        {/* เเจ้งเตือน */}
        {/* <li>
                    <Menu>
                        <MenuHandler>
                            <button onClick={() => { }} className="flex h-full outline-none items-center mr-3 relative">
                                <img className="w-[48px] h-[48px] rounded-full" src="/notify.svg" alt="notify" />
                                <div className={`absolute top-[-5px] right-[-5px] shadow w-5 h-5 text-[0.65rem] leading-tight font-medium rounded-full flex items-center justify-center cursor-pointer hover:scale-110 transition-all duration-300 bg-[#EC3B3B] text-[#FFFFFF] shadow-[#EC3B3B]`}>{getNotificationTotal}</div>
                            </button>
                        </MenuHandler>
                        <MenuList className={`flex flex-col ${notifyList.length > 0 ? 'mt-7 w-80 rounded-2xl' : 'rounded-xl'} z-[19] `}>
                            <div className='h-full'>
                                <div className={`${notifyList.length > 3 ? 'overflow-y-scroll' : 'overflow-hidden'} `}>
                                    <div className={`${notifyList.length > 3 ? 'h-[300px]' : ''} `}>
                                        {notifyList.length ? <>
                                            {
                                                notifyList.map((i, idx) => (
                                                    <button key={idx} className="grid py-1 rounded-lg px-[15px] w-full">
                                                        <div onClick={() => {

                                                        }}
                                                            className="hover:rounded-lg hover:bg-[#fdf4f0] p-[5px]"
                                                        >
                                                            <div className="grid grid-cols-[auto_50px] justify-between font-bold py-[5px]">
                                                                <div>{i['payload']['topic']}</div>
                                                                <div className="text-[#FFC0A4]">{i['create_date']['time']}</div>
                                                            </div>
                                                            <div className="text-[#FF9768] flex justify-start py-[5px]">
                                                                {i['payload']['detail']}
                                                            </div>
                                                            <div className="border-[1px] border-solid border-[#FF9768] w-full bg-[#FF9768] mt-[10px]"></div>
                                                        </div>
                                                    </button>
                                                ))
                                            }
                                        </> : <div className="text-center text-[#2E2E2E] font-medium">ไม่พบการแจ้งเตือน</div>}
                                    </div>
                                </div>
                            </div>
                        </MenuList>
                    </Menu>
                </li> */}
        {/* ข้อมูลส่วนตัว */}
        <li>
          <MenuInfoProvideradmin />
        </li>
      </ul>
    </nav>
  );
}

export default MenuProvideradmin;
